import { render, staticRenderFns } from "./AtributeTabs.vue?vue&type=template&id=424370fc&scoped=true&"
import script from "./AtributeTabs.vue?vue&type=script&lang=js&"
export * from "./AtributeTabs.vue?vue&type=script&lang=js&"
import style0 from "./AtributeTabs.vue?vue&type=style&index=0&id=424370fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424370fc",
  null
  
)

export default component.exports